// @ts-check
import { Button } from '~/design-system';

export default function MailToButton({
  email,
  subject = '',
  children,
  ...rest
}) {
  return (
    <Button
      variant="primary"
      onClick={(e) => {
        window.location = `mailto:${email}?subject=${subject}`;
        e.preventDefault();
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
